import * as React from "react";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { wrap } from "popmotion";
import ViewPokomonInfo from "../microComponents/ViewPokemonInfo";
import  { Card, CardButtonWrapper } from "../microComponents/CardModels";
 import { getAllPokemons } from "../../redux/actions/allPokemonActions";
 import { useDispatch, useSelector } from "react-redux";
import { addPokemonToCart, clearErrors, addPokemonToWishlist } from "../../redux/actions/cartAndWishlistActions";
import { Link, useHistory } from "react-router-dom";
import { SearchPokemon } from "../microComponents/SearchPoke";


//___animations
const variants = {
  enter: (direction) => {
    return {
      x: direction > 0 ? 500 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};


const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};



export const SwapSlide = () => {

    const [selectedPokes, setSelectedPokes] = useState("")
    const [[page, slideDirection], setSlideDirection] = useState([0, 0]);
     const [isInWishlist, setIsInWishList] = useState([]);

    const dispatch = useDispatch();
    let history = useHistory();

    let {allPokemons, error, loading}  = useSelector((state) => state.pokemons)

     let wishList  = useSelector((state) => state.addToWishlist.wishListItems)

 
     //___slide left or right
      const paginate = (newDirection) => {
           setSlideDirection([page + newDirection, newDirection]);
           setSelectedPokes("")  //vry last        
      };
   


      // _________handle on click  
      const handleOnClickActions = async(id) => {
             dispatch(addPokemonToWishlist(id))
                 alreadyInWishList(id)
            }

      const handleBuyNow = (id) => {
      dispatch(addPokemonToCart(id))
      history.push("/cart");
   }


     const alreadyInWishList = async(id) => {

          let foundItem = await wishList.filter((el) => el.id === id);
                setIsInWishList(foundItem && foundItem);
                if(foundItem.length){
                    setTimeout(() => setIsInWishList([]), 3000);
                }
       }




      useEffect(() => { 

              dispatch(getAllPokemons()); 
              dispatch(clearErrors())

     }, [dispatch])

  
      return ( 
            <>
              {

                 allPokemons && allPokemons.length ?  ([...allPokemons].sort(() => 0.5 - Math.random()).slice(0,16).reduce((result, data, i, arr) => {

                     const contentIndex =  wrap(0, arr.length, page);

                     //  const indexOfSelectedPoke  =  arr.findIndex((el, i) => typeof el.name === "string" &&  el.name === selectedPokes);
                     //  const contentIndex = selectedPokes? indexOfSelectedPoke : wrap(0, arr.length, page);
                     const getItemByIndex =  arr.find((el, index) => typeof el.name === "string" &&  index === contentIndex);

                  result = {
                             cardItems: getItemByIndex,
                             searchItems: arr.map(poke=>poke)
                  }

                  return (
                            <>
                              <AnimatePresence initial={false} custom={slideDirection} >
                                <div className="pokeWrapper 
                                "
                              >
                                <React.Fragment key={i}>
                                
                                  <div className=" sliderWrapper 
                                  ">
                                    
                                     <div className="leftWrapper">

                                    <motion.div
                                          key={page}
                                          custom={slideDirection}
                                          variants={variants}
                                          initial="enter"
                                          animate="center"
                                          exit="exit"
                                          transition={{
                                          x: { type: "spring", stiffness: 100, damping: 30 },
                                          opacity: { duration: 0.2 }
                                          }}
                                          drag="x"
                                          dragConstraints={{ left: 0, right: 0 }}
                                          dragElastic={1}

                                          onDragEnd={(e, { offset, velocity }) => {
                                            const swipe = swipePower(offset.x, velocity.x);

                                              if (swipe < -swipeConfidenceThreshold) {
                                                paginate(+1);
                                              } else if (swipe > swipeConfidenceThreshold) {
                                                  paginate(-1);
                                              }
                                          }}
                                      >  
                                          <div className="cardWrapper  thumb-container">
                                                 <Card result={result} paginate={paginate}/>
                                          </div>
                                      </motion.div>
                                              <CardButtonWrapper paginate={paginate}/>
                                    </div>
                                    <div className="rightWrapper">
                                            {/* search */}
                                           <div className="searchPokeWrapper">
                                                 <SearchPokemon
                                                    result={result} 
                                                    // onChangeHandler={onChangeHandler}
                                                 />

                                            </div>
                                            <div className="ViewPokomonInfoWrappper">
                                                <ViewPokomonInfo result={result} paginate={paginate}
                                                  handleOnClickActions={handleOnClickActions}
                                                  handleBuyNow={handleBuyNow}
                                                  isInWishlist={isInWishlist}
                                              />
                                            </div>
                                    </div>
                                    </div>
                                </React.Fragment>
                                </div>
                                </AnimatePresence>
                            </>
                  )           
              },[selectedPokes])
                 ): ""
              }
            </>
         )
}  
       